const programs = {
    createProgram: 'Create Programs',
    description:'Program Description'
    
  }
  
  
  export default programs